import { IHeaderParams } from "ag-grid-community";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { HeaderParams } from "@src/components/MainApp/SharedProductPicker/types";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export const ProductListHeader = (
  props: IHeaderParams<ProductPickerSelectedProduct>
) => {
  const headerParams = props.column.getColDef().headerComponentParams as
    | HeaderParams
    | undefined;
  return (
    <Grid container direction={"column"} sx={headerParams?.sx}>
      <IgTypography>{props.displayName}</IgTypography>
    </Grid>
  );
};
